<div class="row page-header">
    <div class="col-12">
        <h1>
            Job Type Vendor Templates
            <small>Define default vendors for each job type</small>
        </h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row" style="margin-bottom: 15px">
                <div class="col-sm-4 col-12 form-group">
                    <label for="jobType" style="margin-right: 5px">Job Type</label>
                    <wj-combo-box
                        [(ngModel)]="selectedJobTypeId"
                        name="jobType"
                        id="jobType"
                        [itemsSource]="jobTypes"
                        [displayMemberPath]="'shortName'"
                        [selectedValuePath]="'id'"
                        (selectedIndexChanged)="onJobTypeChanged()"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        @if (canEdit) {
                            <button
                                class="btn btn-sm btn-primary"
                                style="margin-left: 10px"
                                (click)="manageVendors()"
                                [disabled]="!selectedJobTypeId"
                            >
                                Manage Vendors
                            </button>
                        }
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="120"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-column
                            [header]="'Vendor Name'"
                            [binding]="'vendorName'"
                            [minWidth]="300"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Vendor ID'"
                            [binding]="'vendorId'"
                            [width]="120"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
